import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, QuantityUnit } from "__generated__/graphql";

export const OogSchema: RegistryItem = {
	[AgreementTypeEnum.Oog]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.QuantityUnit,
				quantityUnit: QuantityUnit.Oog,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
			"agreement.conditions": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
			"calculationMethod.quantityUnit": { rules: { hidden: true } },
		},
	},
};
